import { Datasets } from "@/components/ImpactReferenceSelector/Datasets";
import ImpactReferenceSelector, {
  ImpactReferenceSelectedContentProps,
} from "@/components/ImpactReferenceSelector/ImpactReferenceSelector";
import useAnalytics from "@/hooks/useAnalytics";
import { ImpactDataset } from "@/hooks/useEcoInventDatasets";
import useTranslation from "@/hooks/useTranslation";
import { message } from "antd";
import { useState } from "react";
import { useGetConsumable, usePatchConsumable } from "../useConsumables";

export default function ConsumableEndOfLife({ consumableId }: { consumableId: number }) {
  const { data: consumable, isLoading } = useGetConsumable({ consumableId });

  const [selectedDataset, setSelectedDataset] = useState<ImpactDataset>();
  const patchConsumable = usePatchConsumable();

  const analytics = useAnalytics();
  const translation = useTranslation();

  const onSubmit = () => {
    if (selectedDataset) {
      return patchConsumable
        .mutateAsync({
          consumableId,
          patch: {
            eol_impact_dataset_id: selectedDataset.id,
          },
        })
        .then(() => {
          analytics.track(`Impact Reference Updated`);
        })
        .catch(() => {
          message.error(translation.errors.general);
        });
    }
  };

  const onDelete = () =>
    patchConsumable
      .mutateAsync({
        consumableId,
        patch: {
          clear: ["eol_impact_dataset_id"],
        },
      })
      .then(() => {
        analytics.track("Impact Reference Deleted");
      })
      .catch(() => {
        message.error(translation.errors.general);
      });

  const selectedContent: ImpactReferenceSelectedContentProps = {
    type: "consumable",
    name: consumable?.name || "",
  };

  const onDatasetChange = (dataset?: ImpactDataset) => {
    setSelectedDataset(dataset);
  };

  const loadingStates = {
    data: isLoading,
    onDatasetConfirm: patchConsumable.isLoading,
  };

  return (
    <ImpactReferenceSelector
      confirmedDataset={consumable?.eol_impact_dataset || undefined}
      selectedDataset={selectedDataset}
      onDatasetChange={onDatasetChange}
      loading={loadingStates}
      modalTitle={"Edit end of life impact reference"}
      showIncomplete={true}
      onDatasetConfirm={onSubmit}
      onDelete={onDelete}
      selectedContent={selectedContent}
      defaultTab={"suggestions"}
      suggestionTabContent={
        <Datasets
          key="EOL"
          selectedDataset={selectedDataset}
          onDatasetChange={onDatasetChange}
          datasetType="eol"
        />
      }
    />
  );
}
